import { AuthService } from '../../service/auth.service';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { SignInOutcome } from 'src/app/domain';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { HttpCloudflareService } from 'src/app/service/http-cloudflare.service';
import { AppToastService } from 'src/app/components/toasts/app-toast.service';

declare const turnstile: any; // Declare turnstile globally
@Component({
	selector: 'app-sign-in',
	templateUrl: './sign-in.component.html',
	styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit, AfterViewInit {
	username = '';
	password = '';
	showFailed = false;
	error: string;

	siteKey = environment.turnstile.siteKey;
	turnstileToken: string | null = null;

	signInButtonDisabled = environment.turnstile.use;

	constructor(
		private authService: AuthService,
		private cloudflareService: HttpCloudflareService,
		private toastService: AppToastService,
	) { }

	ngOnInit(): void {
		this.username = '';
		this.password = '';
	}

	ngAfterViewInit() {
		if (!environment.turnstile.use) {
			return;
		}
		// Ensure the script is loaded before calling turnstile
		if (typeof turnstile !== 'undefined') {
			this.renderTurnstile();
		} else {
			// Wait for the script to load
			window.onload = () => {
				this.renderTurnstile();
			};
		}
	}

	renderTurnstile() {
		turnstile.render('#turnstile-widget', {
			sitekey: this.siteKey,
			callback: (token: string) => {
				this.turnstileToken = token; // Store the token
				console.log('Turnstile token:', token);
				// call backend to verify token
				this.verifyToken();
			},
			'error-callback': (errorCode: string) => {
				console.error('Turnstile error:', errorCode);
				this.turnstileToken = null;
			},
			'expired-callback': () => {
				console.log('Turnstile token expired');
				this.turnstileToken = null;
			}
		});
	}

	verifyToken() {
		// call backend to verify token
		this.cloudflareService.verify(this.turnstileToken).subscribe(
			(response) => {
				if (response.success) {
					const verificationData = {
						verified: true,
						timestamp: Date.now()
					};
					localStorage.setItem('turnstileData', JSON.stringify(verificationData));
					this.signInButtonDisabled = false;

				} else {
					this.toastService.showDanger({ content: "Token verification failed" });
				}
			},
			(error) => {
				this.toastService.showDanger({ content: "Token verification failed: " + error.message });
			}
		);
	}

	doSignIn() {
		this.showFailed = false;
		this.error = null;
		this.authService.signIn(this.username, this.password).subscribe(item => {
			this.password = undefined;

			if (item.error) {
				this.showFailed = true;
				this.error = item.error.statusText ? item.error.statusText : item.error;
			}
		});
	}
}
